import React from "react";
import Menu from '../components/Menu';
import Header from '../sections/Header'
import Welcome from "../sections/Welcome";
import TaxStrip from "../sections/TaxStrip";
import Counter from "../sections/Counter";
import ImageDiscription from "../sections/ImageDiscription/imageDiscription";
import Features from "../sections/Features";
import PlayToEarn from "../sections/PlayToEarn";
import ElonsTweet from "../sections/ElonsTweet";
import Footer from "../components/Footer/footer";

const Home = () => {
    return(
        <div>
            <Menu />
            <Header />
            <Welcome />
            <Counter />
            <TaxStrip />
            <ImageDiscription />
            <Features />
            <PlayToEarn />
            <ElonsTweet />
            <Footer />
        </div>
    )
}

export default Home;